import { render, staticRenderFns } from "./ourHelp.vue?vue&type=template&id=9dada560&scoped=true"
import script from "./ourHelp.vue?vue&type=script&lang=js"
export * from "./ourHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dada560",
  null
  
)

export default component.exports